import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import useTranslation from 'Hooks/useTranslation';
import { Draggable } from 'react-beautiful-dnd';
import { DragIndicator, CircleOutlined } from '@mui/icons-material';
import { Checkbox } from '@mui/material';
import { NO_EMPTY_NO_EMPTY_SPACES } from 'Constants/Regex';
import TextInput from 'Components/FormComponents/TextInput';
import { OptionContainer, Main, AnswerRadio, iconStyle, dragStyle, greyText } from './style';

function Answer({
  answer,
  answerOptions,
  position,
  positionQuestion,
  question,
  isCorrectHandler,
  formData,
  setFormData,
  isLastItem,
  setUnchanged,
}) {
  const [answerData, setAnswerData] = useState({ ...answer });
  const { t2 } = useTranslation('EditCourse');

  const addOption = () => {
    if (answerOptions.length < 10) {
      const formDataCopy = _.cloneDeep(formData);
      formDataCopy.questions[positionQuestion].answers = [
        ...answerOptions,
        {
          id: `${question.id}-answer_${uuidv4()}`,
          order: answerOptions.length + 1,
          isCorrect: false,
          response: '',
        },
      ];
      setFormData(formDataCopy);
    }
  };

  const deleteHandler = () => {
    if (answerOptions.length > 1) {
      const formDataCopy = _.cloneDeep(formData);
      formDataCopy.questions[positionQuestion].answers.splice(position, 1);
      setFormData(formDataCopy);
      setUnchanged(false);
    }
  };

  const handleCheck = event => {
    const formDataCopy = _.cloneDeep(formData);
    const answerObj = formDataCopy.questions[positionQuestion].answers[position];

    if (event.target.checked === true) {
      answerObj.isCorrect = true;
      formDataCopy.questions[positionQuestion].answers[position] = answerObj;
      setFormData({ ...formDataCopy });
      isCorrectHandler(position);
      setUnchanged(false);
    } else {
      answerObj.isCorrect = false;
      formDataCopy.questions[positionQuestion].answers[position] = answerObj;
      setFormData({ ...formDataCopy });
      setUnchanged(false);
    }
  };

  const handleAnswerChange = event => {
    setAnswerData({
      ...answerData,
      [event.target.name]: event.target.value,
    });
    setUnchanged(false);

    if (isLastItem) {
      addOption();
    }
  };

  const onAnswerBlur = event => {
    const formDataCopy = _.cloneDeep(formData);
    formDataCopy.questions[positionQuestion].answers[position] = {
      ...answerData,
      response: event.target.value,
    };

    if (
      (answerData.response.match(NO_EMPTY_NO_EMPTY_SPACES) || answerData.response.length < 1) &&
      position !== answerOptions.length - 1
    ) {
      setFormData({
        ...formDataCopy,
        errors: {
          ...formDataCopy.errors,
          [`question-${question.id}_answer-${answer.id}`]: t2('FormErrorEvaluationAnswer'),
        },
      });

      return;
    }

    delete formDataCopy.errors[`question-${question.id}_answer-${answer.id}`];

    setFormData({ ...formDataCopy });
  };

  return (
    <Draggable
      key={answer.id}
      draggableId={answer.id}
      index={position}
      isDragDisabled={answerData?.response?.length === 0}
    >
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <OptionContainer>
            <Main>
              <div {...provided.dragHandleProps}>
                <DragIndicator style={dragStyle} />
              </div>
              <CircleOutlined style={iconStyle} onClick={deleteHandler} />
              <TextInput
                name="response"
                size="small"
                sx={{
                  width: '100%',
                  '& .MuiInput-root:before': {
                    borderBottom: 'none',
                  },
                }}
                placeholder={t2('AddOption')}
                variant="standard"
                InputProps={{ disableUnderline: true }}
                value={answerData?.response || ''}
                onChange={handleAnswerChange}
                color="MexlogGreen"
                onBlur={onAnswerBlur}
                errortext={formData.errors[`question-${question.id}_answer-${answer.id}`]}
              />
            </Main>
            <AnswerRadio>
              <Checkbox
                checked={answer.isCorrect}
                onChange={handleCheck}
                inputProps={{ 'aria-label': 'controlled' }}
                disabled={answerData?.response === ''}
              />
              <div style={answerData?.response === '' ? greyText : null}>{t2('CorrectAnswer')}</div>
            </AnswerRadio>
          </OptionContainer>
        </div>
      )}
    </Draggable>
  );
}

export default Answer;
